const doc = [({"ja":({"adminComponentHotelWaitingList":({"hotelWaitingListIndexTitle":"空室待ちリスト"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;